// Shared empty state. Modeled on the Stats empty state (icon + message +
// optional CTA), now reused by Home, History, Settings, Round, etc.
//
// Props:
//   icon     optional node rendered in the icon slot (e.g. an <svg>)
//   title    optional bold/heading line
//   message  primary copy (string or node). `children` works too.
//   action   optional CTA node (a <Link> or <button>)
//   variant  "card" (default — boxed, centered, like Stats) or
//            "inline" (compact, no box — for in-panel / muted spots)
//   className extra classes appended to the wrapper
//   style    passthrough inline style

export function EmptyState({
  icon,
  title,
  message,
  action,
  children,
  variant = "card",
  className = "",
  style,
}) {
  const cls = ["empty-state", `empty-state--${variant}`, className]
    .filter(Boolean)
    .join(" ");
  const body = message ?? children;
  return (
    <div className={cls} style={style}>
      {icon && <div className="empty-state-icon">{icon}</div>}
      {title && <p className="empty-state-title">{title}</p>}
      {body != null && <p className="empty-state-msg">{body}</p>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
}
